export default function FinalCTA() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="final-cta" className="py-20 sm:py-28 bg-gradient-to-br from-teal-600 via-sky-600 to-teal-700 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-80 h-80 bg-white rounded-full -translate-y-1/2 blur-2xl"></div>
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-white rounded-full translate-y-1/2 blur-2xl"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/15 border border-white/25 rounded-full mb-6">
          <i className="ri-sparkling-line text-teal-200"></i>
          <span className="text-sm font-semibold text-white">Your Journey Starts Here</span>
        </div>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-5 leading-tight">
          Start Your Safe Care Journey Today
        </h2>

        <p className="text-lg sm:text-xl text-white/80 mb-10 max-w-2xl mx-auto leading-relaxed">
          Join thousands of families who use MomsFirstCare to navigate pregnancy and baby care with confidence, clarity, and zero stress.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <button
            onClick={() => scrollToSection('how-it-works')}
            className="px-10 py-4 bg-white text-teal-700 rounded-xl font-bold text-lg hover:bg-teal-50 transition-all hover:-translate-y-1 whitespace-nowrap"
          >
            Get Started Free
          </button>
          <button
            onClick={() => scrollToSection('features')}
            className="relative px-10 py-4 bg-transparent border-2 border-white/50 text-white rounded-xl font-bold text-lg hover:bg-white/10 hover:border-white transition-all hover:-translate-y-1 whitespace-nowrap"
          >
            Try Your Care Plan
            <span className="absolute -bottom-5 left-1/2 -translate-x-1/2 text-xs text-white/60 font-normal whitespace-nowrap">Coming Soon</span>
          </button>
        </div>

        {/* Trust micro-copy */}
        <div className="flex flex-wrap gap-6 justify-center text-white/70 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-teal-200 text-base"></i>
            <span>No signup required</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-teal-200 text-base"></i>
            <span>Always free to use</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-teal-200 text-base"></i>
            <span>Govt. guideline compliant</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-teal-200 text-base"></i>
            <span>Built for Indian families</span>
          </div>
        </div>
      </div>
    </section>
  );
}
